import { db } from '../firebaseInit'
// import router from '../router'
import _ from 'lodash'
import moment from 'moment'

export default {
  state: {
    allTasksList: [],
    getProjectTask: [],
    buildCompleteId: null,
    taskFiles: [],
    projectTasks: [],
    proceed: false
  },
  mutations: {
    editTask (state, payload) {
      // Convert JS Dates to seconds
      if (payload.start_date) {
        payload.start_date = { seconds: Math.round(payload.start_date.getTime() / 1000) }
      }
      if (payload.due_date) {
        payload.due_date = { seconds: Math.round(payload.due_date.getTime() / 1000) }
      }
      if (payload.completed_date) {
        payload.completed_date = { seconds: Math.round(payload.completed_date.getTime() / 1000) }
      }
      // Check Store State for Updates
      if (state.projectTasks.length > 0) {
        const taskIndex = state.projectTasks.findIndex(i => i.id === payload.id)
        const task = { ...state.projectTasks[taskIndex], ...payload }
        state.projectTasks.splice(taskIndex, 1, task)
      }
      if (state.getProjectTask && state.getProjectTask.id === payload.id) {
        state.getProjectTask = { ...state.getProjectTask, ...payload }
      }
    },
    allTasksList (state, payload) {
      state.allTasksList.push(payload)
    },
    getProjectTask (state, payload) {
      state.getProjectTask = payload
    },
    buildComplete (state, payload) {
      state.buildCompleteId = payload
    },
    newProjectTask (state, payload) {
      state.projectTasks.push(payload.newTask)
    },
    getTaskFiles (state, payload) {
      state.taskFiles = payload
    },
    taskFile (state, payload) {
      state.projectTasks[payload.index].files = payload.data
    },
    completeTask (state, payload) {
      state.projectTasks[payload.index].status = payload.status
      state.projectTasks[payload.index].completed_date = payload.completed_date
      state.projectTasks[payload.index].completed_by = payload.completed_by
      state.projectTasks[payload.index].active = false
    },
    changeDueDate (state, payload) {
      state.projectTasks[payload.index].due_date.seconds = payload.dueDate
    },
    removeChecklistItem (state, payload) {
      state.projectTasks[payload.index].checklist = payload.data
    },
    addNewChecklistItem (state, payload) {
      state.projectTasks[payload.index].checklist = payload.data
    },
    taskExecution (state, payload) {
      state.projectTasks[payload.index].status = payload.status
    },
    setProceed (state, payload) {
      state.proceed = payload
    },
    destroyProjectTasks (state) {
      state.projectTasks = []
    },
    getProjectTasks (state, payload) {
      state.projectTasks = payload
    }
  },
  actions: {
    editTask ({ commit, getters, dispatch }, payload) { // Edits task(s) in DB. Send an array of objects with a required task "id" and any other fields to add/overwrite
      // i.e. [ { id: XXXXXXXXXX, name: 'New Task Name' }, { id: XXXXXXXXXX, name: 'New Task Name2' } ]
      // MUST PASS OBJECT with DATES in JAVASCRIPT format new DATE() - Do not pass seconds
      if (!Array.isArray(payload)) { // If the passed payload is not an array - make it one.
        payload = [ payload ]
      }
      payload.forEach(task => {
        // Fix Possible Date Issues
        if (task.due_date && task.due_date.seconds) { task.due_date = new Date(task.due_date.seconds * 1000) }
        if (task.start_date && task.start_date.seconds) { task.start_date = new Date(task.start_date.seconds * 1000) }
        if (task.completed_date && task.completed_date.seconds) { task.completed_date = new Date(task.completed_date.seconds * 1000) }
        // Update Tasks Table in DB
        let writeTask = Object.assign({}, task)
        delete writeTask.id
        db.collection('tasks').doc(task.id).update(writeTask)
        .then((response) => {
          commit('editTask', task)
          dispatch('updateFilteredTasks', task)
          // Check to see if it contains the following fields: If so... Proceed to editing the project task object
          const allowedFields = ['active', 'after_task', 'due_date', 'phase', 'name', 'start_date', 'status', 'completed_date', 'vendor_id', 'assigned_to', 'deleted', 'is_double_booked', 'days_due']
          const updateFields = Object.keys(task).filter(f => allowedFields.includes(f))
          if (updateFields && updateFields.length > 0) {
            // Get Project Id From Task
            db.collection('tasks').doc(task.id).get().then(response => {
              const projectId = response.data().projectId
              let taskData = Object.assign({}, task)
              delete taskData.id
              // Update Project Tasks in List in Projects
              db.collection('projects').doc(projectId).get().then(projectResponse => {
                const project = projectResponse.data()
                const taskList = project.tasks
                updateFields.forEach(key => {
                  // Fix Possible Date Issues
                  if (task[key] && task[key].seconds) {
                    task[key] = new Date(task[key].seconds * 1000)
                  }
                  taskList[task.id][key] = task[key]
                })
                const newTask = taskList[task.id]
                const firestoreTaskKey = 'tasks.' + task.id
                db.collection('projects').doc(projectId).update({ [firestoreTaskKey]: newTask })
                .then(() => {
                  const taskKeys = Object.keys(task)
                  if (taskKeys.length < 3 && (taskKeys.includes('is_double_booked') || taskKeys.includes('checklist'))) { // Do Not Log if only change is in the list
                  } else {
                    const logData = { timestamp: new Date(), collection: 'task', type: 'edit', user_id: getters.user.id, record_id: task.id, message: getters.user.first_name + ' edited the task ' + task.id, icon: 'ballot', changed_to: writeTask }
                    dispatch('commitLog', logData)
                  }
                })
              })
            })
          }
        })
        .catch(error => console.log('An error occured while writing the new task to the database. Error: ', error))
      })
    },
    moveSchedulerDates ({ dispatch }, payload) { // Pass task object
      // Check if tasks have dependencies
      let changeTask = Object.assign({}, payload)
      let project = null
      let changeTasks = []
      changeTasks.push({ task: changeTask, start_date: changeTask.start_date, due_date: changeTask.due_date })
      db.collection('projects').doc(changeTasks[0].task.projectId).get().then(projectResponse => {
        project = projectResponse.data()
      }).then(() => {
        const taskKeys = Object.keys(project.tasks)
        let projectTasks = []
        taskKeys.forEach(key => {
          projectTasks.push({ id: key, ...project.tasks[key], start_date: new Date(project.tasks[key].start_date.seconds * 1000), due_date: new Date(project.tasks[key].due_date.seconds * 1000) })
        })
        let checkedIds = [changeTask.id]
        let allDependancies = []
        // Find Dependancy Chains
        while (checkedIds.length > 0) {
          const allDependanciesIds = allDependancies.map(m => m.task.id)
          const dependancyTasks = projectTasks.filter(f => f.after_task === checkedIds[0])
          dependancyTasks.forEach(task => {
            if (!allDependanciesIds.includes(task.id)) {
              allDependancies.push({ task: task, start_date: task.start_date, due_date: task.due_date })
              checkedIds.push(task.id)
            }
          })
          checkedIds.splice(0, 1)
        }
        while (allDependancies.length > 0) {
          allDependancies.forEach((dependancy, index) => {
            const afterTask = changeTasks.filter(f => f.task.id === dependancy.task.after_task)[0]
            if (afterTask && afterTask.task && dependancy.task.status !== 'Completed') {
              changeTasks.push({ task: dependancy.task, start_date: moment(afterTask.task.start_date).add(parseInt(dependancy.task.days_due), 'days').toDate(), due_date: moment(afterTask.task.due_date).add(parseInt(dependancy.task.days_due), 'days').toDate() })
              allDependancies.splice(index, 1)
            } else if (dependancy.task.status === 'Completed') {
              allDependancies.splice(index, 1)
            }
          })
        }
        changeTasks = changeTasks.map(task => ({ task: task.task, newDueDate: task.due_date, newStartDate: task.start_date }))
        dispatch('changeTaskDates', changeTasks)
      })
    },
    changeTaskDates ({ dispatch }, payload) { // Pass an array of task: task Object, MUST INCLUDE after_task && days_due if a dependancy, newDueDate <optional>, newStartDate <optional>, newCompletedDate <optional>
      if (!Array.isArray(payload)) {
        payload = [ payload ]
      }
      payload.forEach(task => {
        let dispatchPayload = { id: task.task.id }
        if (task.newDueDate) {
          let startingDate = null
          if (task.newStartDate || (task.task.start_date && task.task.start_date.seconds)) {
            startingDate = task.newStartDate ? task.newStartDate : new Date(task.task.start_date.seconds * 1000)
          }
          const dueDateDifference = Math.abs(startingDate - task.newDueDate)
          const daysDue = Math.floor(dueDateDifference / (1000 * 60 * 60 * 24))
          dispatchPayload = { ...dispatchPayload, due_date: task.newDueDate, days_due: daysDue }
          if (task.task.vendor_id) { // Checks if the new date invokes a double book if a vendor is applied
            dispatch('checkVendorDoubleBooked', { taskId: task.task.id, isDoubleBooked: task.task.is_double_booked, vendorId: task.task.vendor_id, dueDate: task.newDueDate })
            dispatch('checkToRemoveDoubleBooked', { taskId: task.task.id, isDoubleBooked: task.task.is_double_booked, vendorId: task.task.vendor_id, dueDate: task.newDueDate })
          }
        }
        if (task.newStartDate) {
          dispatchPayload = { ...dispatchPayload, start_date: task.newStartDate }
        }
        if (task.newCompletedDate) {
          dispatchPayload = { ...dispatchPayload, completed_date: task.newCompletedDate }
        }
        dispatch('editTask', dispatchPayload)
      })
    },
    getAllTasksList ({ commit }) {
      const phases = ['Construction', 'Pre-Construction']
      phases.forEach(phase => {
        db.collection('settings').doc('task_templates').collection(phase).where('deleted', '==', false).get()
        .then(query => {
          query.forEach(item => {
            commit('allTasksList', item.data().name)
          })
        })
      })
    },
    assignTaskUser ({ commit, state, dispatch, getters }, payload) { // Payload = { task: task, project: project, user: user }
      dispatch('editTask', [{ id: payload.task.id, assigned_to: payload.task.assigned_to }])
      const logData = { timestamp: new Date(), collection: 'task', type: 'assign user', user_id: getters.user.id, record_id: payload.task.id, message: getters.user.first_name + ' assigned the user ' + payload.user.first_name + ' ' + payload.user.last_name + ' to the task: ' + payload.task.name + ' | ' + payload.project.name, icon: 'ballot' }
      dispatch('commitLog', logData)
      if (getters.user.id !== payload.user.id) {
        const emails = [payload.user.email]
        const emailSubject = 'New Assigned Task: ' + payload.project.name + ' | ' + payload.task.name
        const title = 'New Assigned Task: ' + payload.task.name
        const message = 'You were assigned to the task: ' + payload.task.name + ' - For the project: ' + payload.project.name + '. Make sure to login and see the task status.'
        const url = getters.clientSettings.baseUrl + '/project/' + payload.project.id
        const icon = 'ballot'
        dispatch('notify', {emails, emailSubject, title, message, url, icon})
      }
    },
    getProjectTask ({ commit }, payload) { // payload: {projectId: null, taskName: null}
      db.collection('tasks').where('projectId', '==', payload.projectId).where('name', '==', payload.taskName).get()
        .then(task => {
          task.forEach(singleTask => {
            commit('getProjectTask', singleTask.data())
          })
        })
    },
    newProjectTask ({ commit, state, dispatch, getters }, payload) {
      payload.newTask = { ...payload.newTask, type: payload.project.status, status: 'Not Started', active: true, vendor_id: null, created_date: new Date(), created_by: getters.user.id, projectId: payload.project.id }
      payload.newTask.due_date = new Date(payload.newTask.due_date)
      const taskId = String((new Date()).getTime()) + '-' + Math.floor(Math.random() * 1000)
      payload.newTask.id = taskId
      // Get Current Project Task List
      let projectTaskList = null
      const projectTask = { active: true,
        after_task: payload.newTask.after_task,
        days_due: payload.newTask.days_due,
        due_date: { seconds: payload.newTask.due_date.getTime() / 1000 },
        name: payload.newTask.name,
        start_date: { seconds: payload.newTask.start_date.getTime() / 1000 },
        status: payload.newTask.status,
        type: payload.newTask.type,
        phase: payload.newTask.phase }
      db.collection('projects').doc(payload.project.id).get().then(response => {
        if (response.data().tasks) {
          projectTaskList = response.data().tasks
        }
      }).then(() => {
        if (projectTaskList) {
          projectTaskList = { ...projectTaskList, [payload.newTask.id]: projectTask }
        } else {
          projectTaskList = { [payload.newTask.id]: projectTask }
        }
        db.collection('tasks').doc(taskId).set(payload.newTask).then(() => {
          payload.newTask.due_date.seconds = payload.newTask.due_date.getTime() / 1000
          commit('newProjectTask', payload)
          dispatch('updateFilteredTasks', payload)
          const logData = { timestamp: new Date(), collection: 'task', type: 'created', user_id: getters.user.id, record_id: taskId, message: getters.user.first_name + ' added the task  (' + payload.newTask.name + ') for the project: ' + payload.project.name, icon: 'list_alt' }
          dispatch('commitLog', logData)
          dispatch('addNewTaskToProject', projectTaskList)
          // dispatch('addNewTaskToProject', { project: payload.project, taskId: taskId })
        })
          .then(() => {
            db.collection('projects').doc(payload.project.id).update({
              tasks: projectTaskList
            })
          })
      })
      .catch(error => console.log('An error occured while writing the new task to the database. Error: ', error))
    },
    getTaskFiles ({ commit, state }, payload) {
      const task = _.filter(state.projectTasks, { id: payload.taskId })
      const files = task[0].files
      let fileList = []
      files.forEach(file => {
        db.collection('projects').doc(payload.project.id).collection('files').doc(file).get().then(query => {
          fileList.push(query.data())
        })
          .then(() => {
            commit('getTaskFiles', fileList)
          })
      })
    },
    taskFile ({ commit, dispatch, getters, state }, payload) {
      // Get Current Array
      db.collection('tasks').doc(payload.task_id).get().then(query => {
        let data = []
        if (query.data().files) {
          data = query.data().files
          data.push(payload.file_id)
        } else {
          data.push(payload.file_id)
        }
        db.collection('tasks').doc(payload.task_id).update({
          files: data
        })
          .then(() => {
            const index = state.projectTasks.findIndex(i => i.id === payload.task_id)
            commit('taskFile', { data: data, index: index })
          })
      })
    },
    completeTask ({ commit, dispatch, getters, state }, payload) {
      let sendPayload = { id: payload.task.id, completed_date: new Date(), completed_by: getters.user.id, active: false, status: payload.status }
      dispatch('editTask', sendPayload)
    },
    updateCheckListItems ({ commit, dispatch, getters, state }, payload) {
      dispatch('editTask', { id: payload.task.id, checklist: payload.checklists })
      const logData = { timestamp: new Date(), collection: 'task', type: 'complete checklist', user_id: getters.user.id, record_id: payload.task.id, message: getters.user.first_name + ' worked on the  ' + payload.task.name + ' checklist for the project: ' + payload.project.name, icon: 'check_box', checklist: payload.checklists }
      dispatch('commitLog', logData)
    },
    removeChecklistItem ({ commit, dispatch, getters, state }, payload) {
      let data = payload.task.checklist
      const checklistIndex = data.findIndex(i => i.name === payload.checklistItem && i.active === true)
      data[checklistIndex].active = false
      db.collection('tasks').doc(payload.task.id).update({
        checklist: data
      })
        .then(() => {
          const index = state.projectTasks.findIndex(i => i.id === payload.task.id)
          if (index >= 0) {
            const newPayload = { data: data, index: index }
            commit('removeChecklistItem', newPayload)
          }
          payload.task.checklist = data
          // const summaryPayload = {projectId: payload.project.id, task: payload.task}
          // dispatch('updateSummaryTask', summaryPayload)
          const logData = { timestamp: new Date(), collection: 'task', type: 'remove checklist item', user_id: getters.user.id, record_id: payload.task.id, message: getters.user.first_name + ' removed a checklist item (' + payload.checklistItem + ') from the project ' + payload.project.name + ' from the task: ' + payload.task.name, icon: 'check_box' }
          dispatch('commitLog', logData)
        })
        .catch(error => console.log('An error occurred while writing to the database. Error: ', error))
    },
    addNewChecklistItem ({ commit, dispatch, getters, state }, payload) {
      // Get Current Checklist State (As Firebase Cannot Push Data)
      let data = []
      if (payload.task.checklist) {
        data = payload.task.checklist
      }
      data.push({ active: true, created_date: new Date(), name: payload.checklistItem, completed: false, completed_by: null, completed_date: null })
      db.collection('tasks').doc(payload.task.id).update({
        checklist: data
      })
        .then(() => {
          const index = state.projectTasks.findIndex(i => i.id === payload.task.id)
          if (index >= 0) {
            const newPayload = { data: data, index: index }
            commit('addNewChecklistItem', newPayload)
          }
          payload.task.checklist = data
          // const summaryPayload = {projectId: payload.project.id, task: payload.task}
          // dispatch('updateSummaryTask', summaryPayload)
          const logData = { timestamp: new Date(), collection: 'task', type: 'create checklist item', user_id: getters.user.id, record_id: payload.task.id, message: getters.user.first_name + ' added a new checklist item (' + payload.checklistItem + ') to the project ' + payload.project.name + ' to the task: ' + payload.task.name, icon: 'check_box' }
          dispatch('commitLog', logData)
        })
        .catch(error => console.log('An error occurred while writing to the database. Error: ', error))
    },
    taskExecution ({ commit, dispatch, getters, state }, payload) {
      db.collection('tasks').doc(payload.id).update({
        status: payload.status
      }).then(() => {
        const taskId = 'tasks.' + payload.id
        db.collection('projects').doc(payload.projectId).update({
          [taskId]: { name: payload.name, status: payload.status, due_date: payload.dueDate }
        })
        const index = state.projectTasks.findIndex(i => i.id === payload.id)
        if (index >= 0) {
          const newPayload = { ...payload, index: index }
          commit('taskExecution', newPayload)
        }
        // const { project, projectId, ...summaryPayload } = payload
        // dispatch('updateSummaryTask', {projectId: payload.projectId, task: summaryPayload})
        const logData = { timestamp: new Date(), collection: 'task', type: 'Status Change', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' changed the status of the task (' + payload.name + ') to [' + payload.status + '] for the project: ' + payload.project, icon: 'assignment_ind' }
        dispatch('commitLog', logData)
      })
    },
    setProceed ({ commit }, payload) {
      commit('setProceed', payload)
    },
    destroyProjectTasks ({ commit }) {
      commit('destroyProjectTasks')
    },
    async getProjectTasks ({ commit, dispatch }, payload) {
      dispatch('loading', true)
      // Payload needs taskIds
      let taskArray = []
      return new Promise(resolve => {
        payload.forEach((taskId, index) => {
          db.collection('tasks').doc(taskId[0]).get().then(query => {
            taskArray.push({ ...query.data(), id: query.id })
            if (payload.length - 1 === index) {
              resolve()
            }
          })
        })
      })
        .then(() => {
          return new Promise(resolve => {
            // Do any tasks have Vendors?
            const vendorsExist = _.filter(taskArray, 'vendor_id')
            if (vendorsExist.length > 0) {
              const vendorTasks = _.filter(taskArray, 'vendor_id')
              let passCount = 0
              taskArray.forEach((task, index) => {
                if (task.vendor_id) {
                  db.collection('vendors').doc(task.vendor_id).get()
                    .then(vendors => {
                      if (vendors.data()) {
                        taskArray[index].vendor_name = vendors.data().company_name
                      }
                      passCount++
                      if (passCount === vendorTasks.length) {
                        resolve()
                      }
                    })
                    .catch(error => {
                      console.log('Could not get vendor names. Error: ', error)
                      dispatch('loading', false)
                    })
                }
              })
            } else {
              resolve()
            }
          })
            .then(() => {
              const filteredTasks = taskArray.filter(f => { return f.deleted === false })
              let taskList = []
              filteredTasks.forEach(task => { // Fix for missing fields
                if (!task.assigned_to) {
                  taskList.push({ ...task, assigned_to: [] })
                } else {
                  taskList.push(task)
                }
              })
              commit('getProjectTasks', taskList)
              dispatch('loading', false)
            })
            .catch(error => console.log(error))
        })
        .catch(error => {
          console.log('Error getting Vendors for Tasks! Error: ', error)
          dispatch('loading', false)
        })
    },
    buildTaskList ({ commit, dispatch, getters }, payload) {
      // Add Days to Date
      function addDays (date, days) {
        const copy = new Date(Number(date))
        copy.setDate(date.getDate() + days)
        return copy
      }
      // Set Up Dynamic Tasks Values
      let itemArray = []
      const taskTemplate = payload.taskTemplate
      payload.taskTemplate.forEach(item => {
        if (item.execution === 'From Task Completion') {
          const afterTaskIdIndex = taskTemplate.findIndex(x => x.id === item.after_task)
          itemArray.push({ createTask: item.id, fromTask: taskTemplate[afterTaskIdIndex].id })
        }
      })
      // Group Dynamic Tasks Objects
      var groups = {}
      itemArray.forEach(item => {
        var list = groups[item.fromTask]
        if (list) {
          list.push(item)
        } else {
          groups[item.fromTask] = [item]
        }
      })
      let taskIds = {}
      let builtTaskList = []
      taskTemplate.forEach(array => {
        // If task has dependancy
        let afterTask = null
        if (array.execution === 'From Task Completion') {
          afterTask = taskTemplate.filter(f => f.id === array.after_task)[0]
        }
        // Resume Adding Tasks
        let task = array
        const active = true // Boolean(array.execution !== 'From Task Completion')
        // Initiate Start and Due Dates if dependant on other tasks
        let startDate = new Date(payload.startDate)
        let dueDate = new Date(payload.startDate)
        if (array.execution !== 'From Task Completion') {
          dueDate.setDate(startDate.getDate() + parseInt(array.days_due))
        } else {
          startDate.setDate(startDate.getDate() + parseInt(afterTask.days_due))
          dueDate = addDays(dueDate, array.order)
        }
        if (!task.vendor_id) {
          task = { ...task, vendor_id: null }
        }
        task = { ...task, status: 'Not Started', active: active, due_date: dueDate, created_date: new Date(), created_by: getters.user.id, type: payload.status, projectId: payload.projectId, projectStatus: payload.status, start_date: startDate }
        if (!task.checklist) {
          task = { ...task, checklist: [] }
        }
        // Add Grouped Dynamic task Data (for next task - if Exists) to taskTemplate
        if (groups[array.id]) {
          let taskArray = []
          groups[array.id].forEach(item => {
            taskArray.push(item.createTask)
          })
          task = { ...task, execute_tasks: taskArray }
        }
        // Add Tasks to Database
        builtTaskList.push(task)
        console.log('Sending Tasks To DB', task)
        db.collection('tasks').doc(array.id).set(task)
          .then(() => {
          })
          .catch(error => console.log('Error Adding Tasks To Database: ', error))
        commit('setLoading', false)
      })
      builtTaskList.forEach(item => {
        let taskItems = {
          active: item.active,
          name: item.name,
          status: 'Not Started',
          due_date: item.due_date,
          start_date: item.start_date,
          type: item.type,
          days_due: item.days_due
        }
        if (item.phase) taskItems = { ...taskItems, phase: item.phase }
        if (item.after_task) taskItems = { ...taskItems, after_task: item.after_task }
        if (item.assigned_to) taskItems = { ...taskItems, assigned_to: item.assigned_to }
        if (item.vendor_id) taskItems = { ...taskItems, vendor_id: item.vendor_id }
        if (item.is_double_booked) taskItems = { ...taskItems, is_double_booked: item.is_double_booked }
        taskIds = { ...taskIds, [item.id]: taskItems }
      })
      const newPayload = { projectId: payload.projectId, taskIds: taskIds }
      // Add Tasks To Projects
      // Push Tasks to Project
      // Get Any Previous Tasks
      let taskList = null
      db.collection('projects').doc(newPayload.projectId).get()
        .then(query => {
          if (query.data().tasks) {
            taskList = query.data().tasks
            taskList = { ...taskList, ...newPayload.taskIds }
          } else {
            taskList = newPayload.taskIds
          }
          // Write to Datebase
          db.collection('projects').doc(newPayload.projectId).update({
            tasks: taskList
          })
          commit('setLoading', false)
          commit('setProceed', true)
        }).then(() => {
          // Push Up New Tasks
          let taskArray = Object.keys(taskList).map(key => { return [key] })
          dispatch('getProjectTasks', taskArray)
        })
        .catch(error => console.log('There was an error retrieving previous tasks: ', error))
      commit('setLoading', false)
      // Log the build
      const logData = { timestamp: new Date(), collection: 'project', type: 'build tasks', user_id: getters.user.id, record_id: payload.projectId, message: getters.user.first_name + ' built a new ' + payload.taskTemplate + ' task list for the project: ' + payload.projectName, icon: 'assignment_turned_in' }
      dispatch('commitLog', logData)
    }
  },
  getters: {
    allTasksList (state) {
      return state.allTasksList
    },
    getProjectTask (state) {
      return state.getProjectTask
    },
    buildComplete (state) {
      return state.buildCompleteId
    },
    taskFiles (state) {
      return state.taskFiles
    },
    projectTasks (state) {
      return state.projectTasks
    },
    proceed (state) {
      return state.proceed
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/tasks.js